export default __webpack_public_path__ + "static/media/dark-mode.b0756d2e.svg";